import React from 'react'
import Profile from '../../Components/api/Spotify/Profile'
import Layout from '../../Components/Layout/Layout'

function SpotifyPage() {
    return (
        <Layout>
            <section className={"card-section"}>
                <Profile/>
            </section>
        </Layout>
    )
}

export default SpotifyPage
